// https://coolors.co/f94144-f3722c-f8961e-f9c74f-90be6d-43aa8b-577590
export enum COLORS {
    'redsalsa',
    'orangered',
    'yelloworange',
    'maizecrayola',
    'pistachio',
    'zomp',
    'queenblue'
}